import { useEffect } from "react";

export interface SceneNumberingNoticeDialogProps {
  onDismiss: () => void;
  kind?: "scene" | "episode";
}

/**
 * Shown the first time a scene/episode number is edited while numbering
 * is still sequential — it then switches to custom numbers.
 */
export function SceneNumberingNoticeDialog({
  onDismiss,
  kind = "scene",
}: SceneNumberingNoticeDialogProps) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onDismiss();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onDismiss]);

  const scene = kind === "scene";

  return (
    <div
      className="sm-dialog-backdrop"
      role="presentation"
      onClick={onDismiss}
    >
      <div
        className="sm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sm-scene-numbering-notice-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="sm-scene-numbering-notice-title">
          {scene
            ? "Brugerdefinerede scenenumre"
            : "Brugerdefinerede episodenumre"}
        </h2>
        <p>
          {scene
            ? "Episodens indstillinger ændres nu til brugerdefinerede scenenumre. Det betyder, at ingen scener automatisk vil blive tildelt nye numre, hvis du sletter eller bytter om."
            : "Produktionens indstillinger ændres nu til brugerdefinerede episodenumre. Det betyder, at ingen episoder automatisk vil blive tildelt nye numre, hvis du tilføjer eller sletter."}
        </p>
        <div className="sm-dialog-actions">
          <button
            type="button"
            className="sm-dialog-primary"
            onClick={onDismiss}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
